import React, { useEffect, useState } from 'react';
import { Box, Image, Text } from '@chakra-ui/react';
import { getBaseUrl } from 'api';
import { AxiosError } from 'axios';
import { WidgetData, Location } from '../types';
import {
  MainPageHeader,
  Page,
  Plate,
  Loader,
  QuickSearch,
  NotFoundAlert,
} from '../components';

export const LocalityPage: React.FC<{
  data: WidgetData;
  loading?: boolean;
  error?: AxiosError<unknown> | boolean;
  localities: Location[];
  setLocality: (locality: Location) => void;
}> = ({ data, loading, error, localities, setLocality }) => {
  const [filteredLocations, setFilteredLocations] =
    useState<Location[]>(localities);
  const [searchValue, setSearchValue] = useState<string>('');

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearchValue(event.target.value);

  const filterValues = (searchText: string, list: Location[]): Location[] => {
    if (!searchText) return list;
    return list.filter((item) =>
      item.locality.toLowerCase().includes(searchText.toLowerCase()),
    );
  };

  useEffect(() => {
    const Debounce = setTimeout(() => {
      const values = filterValues(searchValue, localities);
      setFilteredLocations(values);
    }, 300);

    return () => clearTimeout(Debounce);
  }, [searchValue, localities]);

  return (
    <Page
      title={
        <MainPageHeader name={data.company.name} type={data.company.type} />
      }
    >
      <Loader loading={loading} error={error} />
      <Box>
        {data.company.pictureId && (
          <Image
            w="100%"
            maxH="306px"
            objectFit="cover"
            borderRadius={{
              base: '8px',
              md: '20px',
            }}
            src={`${getBaseUrl()}/booking-widget/client/attachment/file/${
              data.company.pictureId
            }/inline`}
            alt="Фото"
            loading="eager"
            mb="4"
          />
        )}
        {data?.company?.description !== '' && (
          <Text
            color="black"
            textStyle="body1"
            whiteSpace="pre-wrap"
            translate="no"
          >
            {data.company.description}
          </Text>
        )}
        <QuickSearch
          value={searchValue}
          onChange={handleFilterChange}
          placeholder="Поиск города"
        />
        <Box w="100%" borderRadius="lg">
          {filteredLocations?.length ? (
            filteredLocations.map((item) => (
              <Plate key={item.locality} onClick={() => setLocality(item)}>
                <Box ml={4}>
                  <Text color="black" textStyle="h4">
                    {item.locality || ' ->>> Город не указан'}
                  </Text>
                </Box>
              </Plate>
            ))
          ) : (
            <NotFoundAlert text="Город не найден" />
          )}
        </Box>
      </Box>
    </Page>
  );
};
